<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios';
import {getEnterpriseInfo} from '@/services/qiye'
export default {
  name: 'App',
  data: function(){
    return {
      componey:'',
    }
  },
  mounted() {
        function checkIE() {
          return (
            '-ms-scroll-limit' in document.documentElement.style &&
            '-ms-ime-align' in document.documentElement.style
          )
        }
        if (checkIE()) {
          window.addEventListener(
            'hashchange',
            () => {
              const currentPath = window.location.hash.slice(1)
              if (this.$route.path !== currentPath) {
                this.$router.push(currentPath)
              }
            },
            false
          )
        }
      }

}
</script>

<style>
@import url("style/style.css");
.el-upload__input{
  display: none !important;
}

.slick-prev:before,.slick-next:before{
    display: none !important;
    opacity:0 !important;
}

.tl-page button{
    width: 36px;
    height: 36px;
    line-height: 34px;
    text-align: center;
    color: #333;
    font-size: 14px;
    border: 1px solid #f4f5f7;
    transition: .3s;
    font-weight:normal;
    margin:0 5px !important;
    background:#fff !important;
}
.tl-page .el-pager li{
      display: block;
    width: 36px;
    height: 36px;
    line-height: 34px;
    text-align: center;
    color: #333;
    font-size: 14px;
    border: 1px solid #f4f5f7;
    transition: .3s;
    font-weight:normal;
    float: left;
    margin:0 5px !important;
    background:#fff !important;
}
.tl-page .el-pager .active{
  background:#1d1d71 !important;
  color:#fff !important;
}
.tl-page button:hover,.tl-page .el-pager li:hover{
  background:#1d1d71 !important;
  color:#fff !important;
}

/* .index-banner .el-carousel__container{
    height:490px !important;
} */

h3{
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue